import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ConstantsService } from '@app/services/constants.service'
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { Messages } from '@app/util/messages'
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private isOpen = false;
  constructor(private router: Router, private constService: ConstantsService, public dialog: MatDialog) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((error: any) => {
      // Skip unauthorized error handling for workflow summary endpoints
      const isWorkflowSummaryEndpoint = request.url.includes('/wkfl-sum');
      
      if (error.status === this.constService.STATUS_CODES.unAuthorized && !this.isOpen && !isWorkflowSummaryEndpoint) {
        this.isOpen = true
        this.dialog.open(ConfirmDialogComponent, {
          data: {
            isAuth: true,
            message: Messages.token_expiry_msg
          },
          disableClose: true
        }).afterClosed().subscribe((res) => {
          if (res === false) {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/'])
          }
        })
      }
      return throwError(error);
    }));
  }
}
